// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_f4-0";